import { useState } from "react";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import { toast } from "react-toastify";
import { Switch } from "@headlessui/react";
import { PropagateLoader } from "react-spinners";
import { UPDATE_RENTA_ARCHIVOS } from "../../../../api/apiFiles";
import SubHeading from "../../../atoms/SubHeading";
import Button from "../../../atoms/Button";
import DatosDeFacturacion from "../DatosDeFacturacion";
import InmuebleDocsList from "./InmuebleDocsList";

const UserRentaTable = ({ data, refetch, loading }) => {
    const [loadingUpdate, setLoadingUpdate] = useState();
    const [clickedOnce, setClickedOnce] = useState(false);
    const [showInactive, setShowInactive] = useState(false);

    const activeRenta = data?.find(r => r.isActive);
    const inactiveRentas = data?.filter(r => !r.isActive);

    let datosFacturacion = activeRenta?.datos_facturacion;

    if (typeof datosFacturacion === "string") {
        try {
            datosFacturacion = JSON.parse(datosFacturacion);
        } catch (error) {
            console.error("Error al parsear datos_facturacion:", error);
            datosFacturacion = {};
        }
    };

    const validationSchema = Yup.object({ });

    const initialValues = {
        fac_rfc: datosFacturacion?.rfc || "",
        fac_razonSocial: datosFacturacion?.razonSocial || "",
        fac_usoCFDI: datosFacturacion?.usoCFDI || "",
        fac_email: datosFacturacion?.email || "",
    };

    const handleSubmit = (values, { setSubmitting }) => {
        if (clickedOnce) return;
        setClickedOnce(true);
        setLoadingUpdate(true);

        const datos_facturacion = {
            razonSocial: values.fac_razonSocial,
            rfc: values.fac_rfc,
            usoCFDI: values.fac_usoCFDI,
            email: values.fac_email
        };

        const updatedValues = { ...values, datos_facturacion: JSON.stringify(datos_facturacion), };

        toast.promise(
            UPDATE_RENTA_ARCHIVOS(activeRenta?.id, {}, updatedValues),
            { pending: 'Editando renta...', success: 'Renta editada correctamente.', error: 'No se pudo editar la renta.' }
        ).then(() => {
            refetch();
        }).catch((error) => {
            console.error(error);
        }).finally(()=> {
            setLoadingUpdate(false);
            setSubmitting(false);
            setTimeout(() => setClickedOnce(false), 9999);
        });
    };

    return (
        <>
            <SubHeading text="Editar información (Para editar documentos haga click en cada uno)" color="black" />
            <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={validationSchema}>
                {({ isSubmitting }) => (
                    <Form className="flex flex-col items-center gap-5">
                        <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-4 ">
                            <DatosDeFacturacion/>
                        </div>
                        <Button
                            type="submit"
                            bgColor="blue"
                            disabled={isSubmitting || loading || loadingUpdate || clickedOnce}
                            text={(isSubmitting || loading || loadingUpdate ) ? <PropagateLoader color="red" /> : "Actualizar"}
                        />
                    </Form>
                )}
            </Formik>
            {activeRenta && (
                <div className="mt-6 w-full">
                    <InmuebleDocsList data={activeRenta} refetch={refetch} />
                </div>
            )}

            <div className="flex items-center gap-4 mt-8">
                <Switch
                    checked={showInactive}
                    onChange={setShowInactive}
                    className={`${
                        showInactive ? 'bg-rs-azul' : 'bg-gray-300'
                    } relative inline-flex h-6 w-11 items-center rounded-full transition`}
                >
                    <span
                        className={`${
                            showInactive ? 'translate-x-6' : 'translate-x-1'
                        } inline-block h-4 w-4 transform rounded-full bg-white transition`}
                    />
                </Switch>
                <span className="text-sm font-medium">Mostrar rentas anteriores</span>
            </div>

            {showInactive && inactiveRentas.map((renta) => (
                <div key={renta.id} className="mt-4 w-full">
                    <InmuebleDocsList data={renta} refetch={refetch} />
                </div>
            ))}
        </>
    );
};

export default UserRentaTable;
